module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./~/@deskproapps/dpat/~/core-js/library/modules/_add-to-unscopables.js
// module id = vSv8
// module chunks = 0